<template>
  <div class="alert-message">
    <h1
      v-if="alert.icon"
      :class="{'text-danger': (alert.variant == null || alert.variant == 'danger'),
               'text-success': (alert.variant == 'success'),
               'text-warning': (alert.variant == 'warning') }"
      class="text-center">
      <i class="material-icons">{{ alert.icon }}</i>
    </h1>
    <h1
      class="text-center"
      v-html="alert.title"/>
    <div
      class="text-center"
      v-html="alert.message"/>

    <div
      v-if="alert.button"
      class="text-center mt-4">
      <button
        type="button"
        class="btn btn-action btn-lg"
        @click="$emit('click')">
        {{ alert.button }}
      </button>
    </div>
  </div>
</template>

<script>
import bModal from 'bootstrap-vue/es/components/modal/modal';

export default {
  components: {
    bModal,
  },
  props: {
    alert: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-message {
  h1 {
    i {
      font-size: 4rem;
    }
  }
}
</style>
